import React from 'react';
import { SparklesIcon, ArrowRightIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
export function ClosingSection() {
  const [ref1, vis1] = useReveal();
  return <section className="relative bg-[#2d1f3d] text-white py-24 md:py-32 px-4 overflow-hidden" data-id="element-131">
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-amber-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-132"></div>

      <div ref={ref1} className={`reveal container mx-auto max-w-3xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-133">
        <div className="mb-8" data-id="element-134">
          <SparklesIcon className="w-8 h-8 text-amber-400 mx-auto mb-6 animate-pulse" data-id="element-135" />
        </div>

        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-136">
          Sana tu vida. Aprende una habilidad real.
          <br className="hidden md:block" data-id="element-137" />{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-white to-amber-200" data-id="element-138">
            Construye una nueva oportunidad.
          </span>
        </h2>

        <div className="relative inline-block mb-12" data-id="element-139">
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-amber-300 rounded-lg blur opacity-20" data-id="element-140"></div>
          <p className="relative text-xl md:text-2xl text-gray-200 font-light leading-relaxed max-w-2xl mx-auto" data-id="element-141">
            Puedes seguir buscando información suelta… <br data-id="element-142" />O puedes elegir una
            formación estructurada que te guíe paso a paso.
          </p>
        </div>

        <div data-id="element-143">
          <a href="#pricing" className="cta-btn group relative inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 sm:px-10 py-4 sm:py-5 rounded-full text-white font-bold text-base sm:text-lg md:text-2xl tracking-widest uppercase transition-all" style={{
          fontFamily: "'Cormorant Garamond', serif",
          letterSpacing: '0.1em',
          background: 'linear-gradient(135deg, #1a6b3a 0%, #2d9a55 50%, #1a6b3a 100%)',
          boxShadow: '0 0 50px rgba(29,107,58,0.55), inset 0 1px 0 rgba(255,255,255,0.15)'
        }} data-id="element-144">
            ✨ ACCEDER A LA FORMACIÓN COMPLETA 🙌
          </a>
        </div>

        <p className="mt-12 text-lg text-amber-200/80 font-serif italic" data-id="element-145">
          ✨ La sanación ya está en vos. Solo necesitás activarla.
        </p>
      </div>
    </section>;
}